import { storage } from "./api";

const KEY = "choremouse_notify";

export function supported() {
  return typeof window !== "undefined" && "Notification" in window;
}

export function isNotifyOn() {
  return storage.get(KEY) === "1";
}

export function notifyReady() {
  return supported() && isNotifyOn() && Notification.permission === "granted";
}

export async function enableNotifications() {
  if (!supported()) return false;
  let perm = Notification.permission;
  if (perm !== "granted") {
    try { perm = await Notification.requestPermission(); } catch (e) { console.debug("notify: permission request failed", e); return false; }
  }
  if (perm === "granted") { storage.set(KEY, "1"); return true; }
  return false;
}

export function disableNotifications() {
  storage.set(KEY, "0");
}

export function pushNote(title, body) {
  try {
    if (notifyReady()) {
      const n = new Notification(title, { body, icon: "/icon-192.png", badge: "/icon-192.png", tag: "choremouse-reminder" });
      setTimeout(() => n.close(), 8000);
    }
  } catch (e) { console.debug("notify: reminder skipped", e); }
}
